<template>
  <v-card class="elevation-12" :loading="loading">
    <v-toolbar
        color="primary"
        dark
        flat
    >
      <v-toolbar-title>{{ $t('registerPage.title') }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-form>
        <v-text-field
            :label="$t('registerPage.labels.tinPinfl')"
            v-model="form.inn"
            type="text"
            maxlength="9"
            :counter="9"
            :error-messages="innErrors"
            @keyup="form.isInnExists = false"
            :disabled="isFormSuccess"
        />

        <v-text-field
            v-model="form.name"
            :label="$t('registerPage.labels.orgName')"
            type="text"
            maxlength="400"
            :counter="400"
            :error-messages="nameErrors"
            :disabled="isFormSuccess"
        />

        <v-text-field
            v-model="form.address"
            :label="$t('registerPage.labels.orgAddress')"
            type="text"
            maxlength="400"
            :counter="400"
            :error-messages="addressErrors"
            :disabled="isFormSuccess"
        />

        <v-text-field
            v-model="form.phoneNumber"
            :label="$t('registerPage.labels.orgPhone')"
            type="text"
            maxlength="12"
            :counter="12"
            :error-messages="phoneNumberErrors"
            :disabled="isFormSuccess"
        />

        <v-text-field
            v-model="form.accountNumber"
            :label="$t('registerPage.labels.accountNumber')"
            type="text"
            maxlength="30"
            :counter="30"
            :error-messages="accountNumberErrors"
            :disabled="isFormSuccess"
        />

        <v-text-field
            v-model="form.mfo"
            :label="$t('registerPage.labels.mfo')"
            type="text"
            maxlength="5"
            :counter="5"
            :error-messages="mfoErrors"
            :disabled="isFormSuccess"
        />

        <v-text-field
            v-model="form.fullname"
            :label="$t('common.labels.fullName')"
            type="text"
            maxlength="400"
            :counter="400"
            :error-messages="fullnameErrors"
            :disabled="isFormSuccess"
        />

        <v-text-field
            v-model="form.username"
            :label="$t('common.labels.login')"
            type="text"
            maxlength="12"
            :counter="12"
            :error-messages="usernameErrors"
            @keyup="form.isUsernameExists = false"
            :disabled="isFormSuccess"
        />

        <v-text-field
            v-model="form.password"
            :label="$t('common.labels.password')"
            type="password"
            :error-messages="passwordErrors"
            :disabled="isFormSuccess"
        />

        <v-text-field
            v-model="form.passwordRepeat"
            :label="$t('common.labels.passwordRepeat')"
            type="password"
            :error-messages="passwordRepeatErrors"
            :disabled="isFormSuccess"
        />

        <v-text-field
            v-model="form.vatRegCode"
            :label="$t('registerPage.labels.vatCode')"
            type="text"
            maxlength="..."
        ></v-text-field>

        <v-text-field
            v-model="form.contractNumber"
            :label="$t('registerPage.labels.contractNumber')"
            type="text"
            maxlength="400"
            :counter="400"
        />

        <v-text-field
            v-model="form.contractSum"
            :label="$t('registerPage.labels.contractSum')"
            type="number"
            step="0.01"
        ></v-text-field>

        <v-checkbox
            v-model="form.isLtd"
            :label="$t('registerPage.checkboxes.individual')"
        ></v-checkbox>

        <v-text-field
            v-model="form.pinfl"
            :label="$t('registerPage.labels.pinfl')"
            type="text"
            maxlength="..."
        ></v-text-field>

        <v-spacer class="py-2"></v-spacer>

        <DateInput v-model="form.contractDateFrom"
                   :label="$t('registerPage.labels.contractDateFrom')"
                   :dense="true"
                   min-width="0"
                   max-width="80%"
        />

        <v-spacer class="py-2"></v-spacer>

        <DateInput v-model="form.contractDateTo"
                   :label="$t('registerPage.labels.contractDateTo')"
                   :dense="true"
                   min-width="0"
                   max-width="80%"
        />

        <v-responsive>
          <v-row>
            <v-col cols="12" class="py-4">
              <v-autocomplete v-model="form.contractSignerUnitId"
                              :items="units"
                              :label="$t('registerPage.labels.contractSignerBranch')"
                              :dense="true"
                              :clearable="true"
                              item-text="name"
                              item-value="id"/>
            </v-col>
            <v-spacer/>
          </v-row>
        </v-responsive>

        <v-checkbox
            v-model="form.HasContractWithGlobalUnit"
            :label="$t('registerPage.checkboxes.hasGlobalContract')"
        ></v-checkbox>


        <v-responsive>
          <v-row>
            <v-col cols="10">
              <v-autocomplete v-model="selectedBranch"
                              :items="branches"
                              :label="$t('registerPage.labels.branches')"
                              :dense="true"
                              :clearable="true"
                              item-text="branch_name"
                              item-value="id"/>
            </v-col>
            <v-col cols="2" >
              <v-btn icon color="primary" @click="loadBranches">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </v-col>
            <p class="pl-3" style="color: #ff0e0e" v-if="showInnRequiredMessage">{{ $t('registerPage.messages.tinRequiredLength') }}</p>
            <v-spacer/>
          </v-row>
        </v-responsive>

        <v-row
        >
          <v-col
              cols="12"
              sm="12"
              md="12"
          >
            <div class="d-flex mb-5 align-center">
              <v-checkbox
                  v-model="form.agreeWithPublicOffer"
                  :label="$t('registerPage.checkboxes.agreeOffer')"
                  color="blue darken-3"
                  :error-messages="publicOfferErrors"
                  :disabled="isFormSuccess"
              >
              </v-checkbox>
              <v-spacer></v-spacer>
              <a href="./Оферта.pdf" target="_blank">{{ $t('registerPage.actions.viewOffer') }}</a>
            </div>
          </v-col>
        </v-row>

        <v-snackbar v-model="isRegistrationFailed"
                    :timeout="5000"
                    :top="true"
                    color="error"
        >
          {{ $t('registerPage.messages.registrationFailed') }}
        </v-snackbar>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" @click="onGoBackClicked">{{ $t('registerPage.actions.back') }}</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="onRegisterButtonClicked" :disabled="isFormSuccess">{{ $t('registerPage.actions.register') }}</v-btn>
    </v-card-actions>

    <v-dialog v-model="signatureForm.signDialog" :persistent="true" width="600px">
      <SignComponent :hash-code="signatureForm.hashCode" @sign="onSign" @cancel="onCancel"/>
    </v-dialog>
  </v-card>
</template>

<script>
import {required, minLength, maxLength, numeric, sameAs} from 'vuelidate/lib/validators'
import AuthService from '../services/auth.service'
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import SignComponent from "./SignComponent";
import _ from "underscore";
import UnitService from "../services/unit.service";
import Mappers from "../mappers";
import BranchService from "@/services/branch.service";
import DateInput from "@/components/input/DateInput.vue";

export default {
  name: "RegisterComponent",
  components: {
    DateInput,
    SignComponent,
  },
  data() {
    return {
      loading: false,
      isRegistrationFailed: false,
      showInnRequiredMessage: false,

      units: [],
      branches: [],
      selectedBranch: '',

      form: {
        inn: '',
        name: '',
        address: '',
        fullname: '',
        username: '998',
        phoneNumber: '998',
        accountNumber: '',
        mfo: '',
        password: '',
        passwordRepeat: '',
        contractNumber: '',
        contractDateFrom: null,
        contractDateTo: null,
        contractSignerUnitId: '',
        agreeWithPublicOffer: null,
        branch : {
          branchName: '',
          branchCode: ''
        },
        vatRegCode: '',
        pinfl: '',
        isLtd: false,
        contractSum: null,
        isUsernameExists: false,
        isInnExists: false,
        HasContractWithGlobalUnit: false
      },

      filterContractDateFromMenu: false,
      filterContractDateFromDisplayValue: '',
      filterContractDateToMenu: false,
      filterContractDateToDisplayValue: '',

      signatureForm: {
        signature: null,
        hashCode: null,
        guid: null,

        signDialog: false
      },
      isFormSuccess: false,
    }
  },
  computed: {
    innErrors() {
      const errors = []
      if (this.$v.form.inn.$dirty) {
        if (!this.$v.form.inn.required) {
          errors.push(this.$t('registerPage.errors.tinRequired'))
        } else {
          !this.$v.form.inn.numeric && errors.push(this.$t('registerPage.errors.tinFormat'))

          if (!this.$v.form.inn.minLength || !this.$v.form.inn.maxLength)
            errors.push(this.$t('registerPage.errors.tinLength'))
        }

        this.form.isInnExists && errors.push(this.$t('registerPage.errors.tinExists'))
      }

      return errors
    },
    nameErrors() {
      const errors = []

      if (this.$v.form.name.$dirty) {
        if (!this.$v.form.name.required) {
          errors.push(this.$t('registerPage.errors.nameRequired'))
        } else {
          !this.$v.form.name.maxLength && errors.push(this.$t('registerPage.errors.nameTooLong'))
        }
      }

      return errors
    },
    addressErrors() {
      const errors = []

      if (this.$v.form.address.$dirty) {
        if (!this.$v.form.address.required) {
          errors.push(this.$t('registerPage.errors.addressRequired'))
        } else {
          !this.$v.form.address.maxLength && errors.push(this.$t('registerPage.errors.addressTooLong'))
        }
      }

      return errors
    },
    fullnameErrors() {
      const errors = []

      if (this.$v.form.fullname.$dirty) {
        if (!this.$v.form.fullname.required) {
          errors.push(this.$t('common.errors.fullNameRequired'))
        } else {
          !this.$v.form.fullname.maxLength && errors.push(this.$t('common.errors.fullNameTooLong'))
        }
      }

      return errors
    },
    usernameErrors() {
      const errors = []
      if (this.$v.form.username.$dirty) {
        if (!this.$v.form.username.required) {
          errors.push(this.$t('common.errors.phoneRequired'))
        } else {
          if (!this.$v.form.username.numeric || !this.$v.form.username.format)
            errors.push(this.$t('common.errors.phoneFormat'))
          if (!this.$v.form.username.minLength || !this.$v.form.username.maxLength)
            errors.push(this.$t('common.errors.phoneLength'))
        }

        this.form.isUsernameExists && errors.push(this.$t('common.errors.loginExists'))
      }

      return errors
    },
    accountNumberErrors() {
      const errors = []

      if (this.$v.form.accountNumber.$dirty) {
        if (!this.$v.form.accountNumber.required) {
          errors.push(this.$t('registerPage.errors.accountRequired'))
        } else {
          !this.$v.form.address.maxLength && errors.push(this.$t('registerPage.errors.accountTooLong'))
        }
      }

      return errors
    },
    mfoErrors() {
      const errors = []

      if (this.$v.form.mfo.$dirty) {
        if (!this.$v.form.mfo.required) {
          errors.push(this.$t('registerPage.errors.mfoRequired'))
        } else {
          !this.$v.form.address.maxLength && errors.push(this.$t('registerPage.errors.mfoTooLong'))
        }
      }

      return errors
    },
    phoneNumberErrors() {
      const errors = []
      if (this.$v.form.phoneNumber.$dirty) {
        if (!this.$v.form.phoneNumber.required) {
          errors.push(this.$t('common.errors.phoneRequired'))
        } else {
          if (!this.$v.form.phoneNumber.numeric || !this.$v.form.phoneNumber.format)
            errors.push(this.$t('common.errors.phoneFormat'))
          if (!this.$v.form.phoneNumber.minLength || !this.$v.form.phoneNumber.maxLength)
            errors.push(this.$t('common.errors.phoneLength'))
        }
      }

      return errors
    },
    passwordErrors() {
      const errors = []

      if (this.$v.form.password.$dirty)
        if (!this.$v.form.password.required)
          errors.push(this.$t('common.errors.passwordRequired'))

      return errors
    },
    passwordRepeatErrors() {
      const errors = []

      if (this.$v.form.passwordRepeat.$dirty)
        if (!this.$v.form.passwordRepeat.required) {
          errors.push(this.$t('common.errors.passwordRepeatRequired'))
        } else {
          !this.$v.form.passwordRepeat.sameAs && errors.push(this.$t('common.errors.passwordsDontMatch'))
        }

      return errors
    },
    publicOfferErrors() {
      const errors = []

      if (this.$v.form.agreeWithPublicOffer.$model === null || this.$v.form.agreeWithPublicOffer.$model === false) {
        errors.push(this.$t('registerPage.errors.confirmAgreement'))
      }

      return errors
    }
  },
  validations: {
    form: {
      inn: {
        required,
        numeric,
        minLength: minLength(9),
        maxLength: maxLength(14)
      },
      name: {
        required,
        maxLength: maxLength(400)
      },
      address: {
        required,
        maxLength: maxLength(400)
      },
      fullname: {
        required,
        maxLength: maxLength(400)
      },
      username: {
        required,
        maxLength: maxLength(12),
        minLength: minLength(12),
        numeric,
        format(value) {
          return /^998\d{9}$/.test(value);
        }
      },
      phoneNumber: {
        required,
        maxLength: maxLength(12),
        minLength: minLength(12),
        numeric,
        format(value) {
          return /^998\d{9}$/.test(value);
        }
      },
      password: {
        required
      },
      passwordRepeat: {
        required,
        sameAs: sameAs(function () {
          return this.form.password
        })
      },
      agreeWithPublicOffer: {
        required
      }
    }
  },
  methods: {
    onGoBackClicked() {
      this.$emit('back')
    },
    loadBaseUnits() {
      this.$store.dispatch(LAYOUT_LOADING_START)
      UnitService.getUserGlobalUnit()
          .then(response => {
            this.units = _.chain(response.data)
                .filter(function (unit) {
                  return unit.IsHead
                })
                .map(function (unit) {
                  return Mappers.mapUnit(unit)
                })
                .value()
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    loadBranches() {
      if (this.form.inn.length === 9) {
        this.$store.dispatch(LAYOUT_LOADING_START)
        BranchService.getBranches({inn: this.form.companyInn})
            .then(response => {
              this.branches = response.data;
            })
            .finally(() => {
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
      }
      else{
        this.showInnRequiredMessage = true;
      }
    },
    onRegisterButtonClicked() {
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.loading = true;
        this.$store.dispatch(LAYOUT_LOADING_START)

        this.form.isUsernameExists = false
        this.form.isInnExists = false

        AuthService.getRegisterHashCode({
          organizationInn: this.form.inn,
          organizationName: this.form.name,
          organizationAddress: this.form.address,
          organizationPhoneNumber: this.form.phoneNumber,
          userFullName: this.form.fullname,
          username: this.form.username,
          password: this.form.password,
          vatRegCode: this.form.vatRegCode,
          branchCode: this.form.branch.branchCode,
          branchName: this.form.branch.branchName,
          isLtd: this.form.isLtd,
          pinfl: this.form.pinfl,
          contractSum: this.form.contractSum,
          contractSignerUnitId: this.form.contractSignerUnitId,
          accountNumber: this.form.accountNumber,
          mfo: this.form.mfo,
          contractNumber: this.form.contractNumber,
          contractDateFrom: this.form.contractDateFrom,
          contractDateTo: this.form.contractDateTo,
          hasContractWithGlobalUnit: this.form.HasContractWithGlobalUnit
        })
            .then(response => {
              if (response.data.Success) {
                this.isFormSuccess = true

                this.signatureForm.signature = null
                this.signatureForm.guid = response.data.Guid
                this.signatureForm.hashCode = response.data.HashCode

                this.signatureForm.signDialog = true
              } else if (response.data.OrganizationInn === 'Exists') {
                this.form.isInnExists = true
              } else if (response.data.Username === 'Exists') {
                this.form.isUsernameExists = true
              }
            })
            .catch(() => {
            })
            .finally(() => {
              this.loading = false;
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
      }
    },
    onSign(signResult) {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      this.isRegistrationFailed = false
      AuthService.register({
        guid: this.signatureForm.guid,
        signature: signResult.pkcs7
      })
          .then(() => {
            this.$emit('registered', {username: this.form.username, password: this.form.password})
          }, () => {
            this.isRegistrationFailed = false
          })
          .catch(() => {

          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    onCancel() {
      this.signatureForm.signDialog = false
      this.isFormSuccess = false
    }
  },
  created() {
    this.loadBaseUnits()
  },
  watch: {
    selectedBranch(newVal) {
      console.log("selectedBranch watcher triggered. New value:", newVal);
      const selectedItem = this.branches.find(item => item.Id === newVal);

      this.form.branch.branchName = selectedItem.BranchName;
      this.form.branch.branchCode = selectedItem.BranchCode;
    },
    'form.inn'(newInnValue) {
      this.showInnRequiredMessage = false;
      this.form.companyInn = newInnValue;
    }
  }
}
</script>

<style scoped>

</style>